module.exports = __webpack_public_path__ + "static/image4-416b93cd36ec24e5fe17b64dbeb62057.jpg";